import { observable, action, computed, flow } from 'mobx';
import { Toast, Modal } from 'antd-mobile';

import utils from 'utils';
import { rstr2b64, hex_md5, Encrypts } from 'utils/md5';
import Config from 'config/Config';
import Stores from 'config/Stores';
import Serv from './AgentRegisterServ';

const Alert = Modal.alert;

class AgentRegisterMod {
  // uniqueId, 获取验证码时，后台返回的，用于后台校验
  // @observable uniqueId = '';
  @observable realName = '';

  @observable phone = '';

  @observable code = '';

  @observable codeLoading = false;

  @observable areaCode = Stores.AppMod.isInternationalized ? 1 : 86;

  // 初始健康顾问、用户编辑的健康顾问
  // @observable initHealthy = '';

  // @observable healthyNum = Stores.AppMod.userInfo.cardCode;

  // 是否同意协议
  @observable isAgree = false;

  @observable cardNum = '';

  @observable password = '';

  @observable healthy = '';

  @observable no_id_used = '';

  @observable usedPhysical = false;

  @observable editSign = true;

  // 获取健康顾问的手机号
  @observable phoneNumber = '';

  // 是否赋百龄云仓下单
  @observable isCloudWarehousecOrder = false;
  @observable showCardTip = false;
  @observable infoData = {};

  @observable globalSaleMode = null;

  isMSZ = '';

  //是否为乐道大单跳转
  ldOrder = '';

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    this[key] = value;
  }

  /**
   * 重置数据
   */
  @action
  clearData() {
    // this.uniqueId = '';
    // this.code = '';
    // this.codeLoading = false;
    this.isAgree = false;
  }

  /**
   * 获取验证码
   */
  // getVerifyCode = flow(function*() {
  //   try {
  //     if (this.codeLoading) return;
  //     this.codeLoading = true;
  //     let params = {
  //       phone: this.phone,
  //       descriptionType: 10, // 10 - 代客注册
  //       codeType: 2, // 1 - 图像验证码，2 - 手机验证码，3 - 邮箱验证码
  //     };
  //     const { data, resultMsg } = yield Serv.getVerifyCode(params);
  //     this.codeLoading = false;
  //     if (data && data.uniqueId) {
  //       Toast.info(resultMsg, 2);
  //       this.uniqueId = data.uniqueId;
  //       // if (data.healthConsultantNum && data.healthConsultantNum != '8888888888') {
  //       //   this.initHealthy = data.healthConsultantNum;
  //       //   this.healthyNum = data.healthConsultantNum;
  //       // }
  //       return data.uniqueId;
  //     }
  //     return null;
  //   } catch (error) {
  //     this.codeLoading = false;
  //     return null;
  //   }
  // });

  /**
   * 获取验证码
   */
  getVerifyCode = flow(function* () {
    const timestamp = new Date().getTime();
    try {
      if (this.codeLoading) return;
      this.codeLoading = true;
      let params = {
        healthConsultantNum: this.healthy,
        phone: this.phone,
        descriptionType: 10, // 10 - 代客注册
        codeType: 2, // 1 - 图像验证码，2 - 手机验证码，3 - 邮箱验证码
        md5Sign: encodeURIComponent(
          Encrypts(
            timestamp +
              '#' +
              hex_md5(this.phone.replace(/\s*/g, '') + utils.getSendMsgParamsUat()).toUpperCase()
          )
        ),
        areaCode: Stores.AppMod.areaCode
      };
      const { data, resultCode, resultMsg } = yield Serv.getVerifyCode(params);
      this.codeLoading = false;
      if (resultCode != '0') {
        Toast.fail(resultMsg, 1);
        return null;
      }
      if (data && data.uniqueId) {
        Toast.info(resultMsg, 2);
        this.uniqueId = data.uniqueId;
        if (data.healthConsultantNum) {
          this.healthy = data.healthConsultantNum;
          if (data.healthConsultantNum != '8888888888') {
            this.editSign = false;
          }
        }
        return data;
      }
      return null;
    } catch (error) {
      console.log('getVerifyCode error', error);
      return null;
    }
  });

  /**
   * 注册
   */
  register = flow(function* (paramsData = {}) {
    try {
      // 是否需要验证码 1 需要 0 不需要
      // const { shopValetVerificationCode } = Stores.AppMod.userInfo
      const { healthy, phone, cardNum, password, no_id_used } = this;
      let params = {
        phone: this.phone,
        uniqueId: this.uniqueId,
        verifyCode: this.code,
        healthConsultantNum: healthy,
        channel: 3, // 注册渠道, 应东哥要求，说是H5传4是错误的，应该是3，但这个4是交付代码
        areaCode: Stores.AppMod.areaCode,
        customerSource: utils.isWeiXin() ? 1 : 5, // 微信 - 0，非微信打开 - 4
        ...paramsData
      };
      const { data } = yield Serv.register(params);
      // this.clearData();

      // this.queryCanApplyType(data.id, data.healthConsultantNum, params.phone);
      // this.getCardTypeInfo(data.id, data.healthConsultantNum, params.phone);
      // utils.setLocalCache(Config.localStorageKeys.store_agentUpgradeMember, { cardCode: memberNum, realName: realName.trim(), dgUserId: res.id });
      // utils.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
      //   dgUserId: res.id,
      //   dgCardCode: memberNum,
      //   cardType: res.cardType,
      //   cardCode: memberNum,
      // });
      // 神策数据发送
      window.sensors.track('register', { phone: params.phone });
      if (data) {
        const {
          cardCode: dgCardCode,
          cardType,
          id: dgUserId,
          realName,
          registerTime,
          extension
        } = data;
        const { saleZone = '' } = Stores.AppMod.userInfo || {};
        localStorage.setItem('dgAreaCode', data.areaCode || 86);
        if (saleZone && data.passwordForThird) {
          // 销售专区
          this.changeState('showCardTip', true);
          this.changeState('infoData', data || {});
          return;
        }

        localStorage.setItem('cloudUserId', dgUserId);
        const store_agentUpgradeMember = {
          dgCardCode,
          dgUserId,
          healthy,
          phone,
          cardNum,
          password,
          no_id_used,
          realName,
          areaCode: data.areaCode
        };
        utils.setLocalCache(
          Config.localStorageKeys.store_agentUpgradeMember,
          store_agentUpgradeMember
        );

        //乐道大单特殊处理
        if (this.ldOrder) {
          this.ldOrderApply(data);
          return;
        }
        // 代客注册转 代客升级
        // 先写死
        // if (!!dgCardCode) {
        //   utils.setLocalCache(Config.localStorageKeys.store_agentUpgradeMember, {
        //     cardCode: dgCardCode,
        //     realName: '',
        //     dgCardCode: dgCardCode,
        //     dgUserId: data.id,
        //   });
        //   utils.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
        //     dgUserId: data.id,
        //     dgCardCode: dgCardCode,
        //     cardType: data.cardType,
        //     cardCode: dgCardCode,
        //   });
        //   const goNextFun = () => {
        //     const applyType = 8;
        //     utils.setLocalCache('memberForUpdate', '');
        //     this.agentApply(applyType, data);
        //   }
        //   Toast.hide();
        //   Stores.AppMod.confirmUpdate({cardCode: dgCardCode, goNextFun, phone, registerTime, password: extension, domId: 'helpUpgrade'});
        //   return
        // }
        this.agentApply(7, data);
      }
    } catch (error) {}
  });

  ldOrderApply = (data) => {
    utils.setLocalCache(Config.localStorageKeys.menber_helpUserId, {
      agentId: data.id,
      phone: this.phone,
      healthConsultantNum: this.healthy // 健康顾问信息
    });
    utils.setLocalCache(Config.localStorageKeys.member_storeAgentApplyCardMsg, {
      healthConsultantNum: this.healthy,
      helpUserId: data.id,
      channel: 2,
      isEntityCard: this.usedPhysical ? 1 : 0 // 0 虚拟卡 1 实体卡
    });

    //跳转到补充资料界面
    window.app.routerGoTo({
      pathname: '/store/businessManage/storeAgentMsg',
      clear: true,
      state: {
        // '7'代表店铺新客注册类型的礼包选购
        applyType: '7',
        ldOrder: true
      }
    });
  };

  /**
   * 新客注册信息提交，获取卡类型
   */
  agentApply = flow(function* (applyType, dataValue) {
    try {
      const { id, healthConsultantNum, cardCode } = dataValue;
      const { healthy } = this;
      let url = '';
      let params = {};
      switch (+applyType) {
        case 7: {
          // 店铺新客注册
          // url = 'user/register/queryCardType';
          url = 'valetOpenCard/queryCardType';
          // user/register/queryCardType
          params = {
            bizValetCardReqDto: {
              healthConsultantNum: healthy,
              helpUserId: id,
              channel: 2,
              isEntityCard: this.usedPhysical ? 1 : 0 // 0 虚拟卡 1 实体卡
            },
            confirmReqDto: {
              userId: Stores.AppMod.userInfo.id,
              channel: 2
            }
          };
          // params = {
          //   registerCardReqDto: {
          //     healthConsultantNum,
          //     helpUserId: id,
          //     isEntityCard: this.usedPhysical ? 1 : 0, // 0 虚拟卡 1 实体卡
          //     channel: 2,
          //     agree: this.isAgree,
          //   },
          // };
          if (this.usedPhysical) {
            params.bizValetCardReqDto.entityCardCode = this.cardNum;
            params.bizValetCardReqDto.entityPassword = rstr2b64(this.password);
          }
          break;
        }
        case 8: {
          // 店铺老客升级
          url = 'valetUpgrade/queryCardType';
          const agentUpgradeMember =
            utils.getLocalCache(Config.localStorageKeys.store_agentUpgradeMember) || {};
          params = {
            bizUpgradeCardReqDto: {
              channel: 3,
              passengerCardCode: agentUpgradeMember.dgCardCode // 客人卡号
            }
          };
          break;
        }
      }
      const { data, resultCode } = yield Serv.getCardTypeList(url, params);
      const cardTypeList = data || [];
      utils.setLocalCache(Config.localStorageKeys.member_cardTypeData, cardTypeList);
      utils.setLocalCache(
        Config.localStorageKeys.member_storeAgentApplyCardMsg,
        params.bizValetCardReqDto
      );
      const theAgentUpgradeMember =
        utils.getLocalCache(Config.localStorageKeys.store_agentUpgradeMember) || {};
      const store_agentUpgradeMember =
        utils.getLocalCache(Config.localStorageKeys.store_agentUpgradeMember) || {};
      utils.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
        dgUserId: id,
        dgMemberInfo: {
          memberCard: theAgentUpgradeMember.dgCardCode || '',
          memberName: theAgentUpgradeMember.realName || '',
          cardType: store_agentUpgradeMember.cardType,
          origin: 'shop'
        }
      });
      utils.setLocalCache(Config.localStorageKeys.menber_helpUserId, {
        agentId: id,
        phone: this.phone,
        healthConsultantNum: this.healthy // 健康顾问信息
      });
      if (applyType == 8) {
        window.app.routerGoTo({
          pathname: '/store/businessManage/businessGiftbag',
          clear: false,
          state: {
            HealthyCardCode: this.healthy,
            applyType: applyType,
            isCloudWarehousecOrder: this.isCloudWarehousecOrder ? 1 : ''
          }
        });
        return;
      }
      window.app.routerGoTo({
        pathname: '/store/businessManage/businessGiftbag',
        clear: true,
        state: {
          applyType,
          HealthyCardCode: this.healthy,
          isCloudWarehousecOrder: this.isCloudWarehousecOrder ? 1 : ''
        }
      });
      return resultCode;
    } catch (error) {}
  });

  // 获取礼包预览信息
  getCardTypeInfo = flow(function* (id, healthConsultantNum, phone) {
    let params = {
      bizValetCardReqDto: {
        healthConsultantNum: this.healthy,
        saleConsultantNum: this.sale,
        realName: this.realName.trim(),
        identityType: this.certType,
        identityCard: this.certNum,
        birthday: this.birth,
        sex: this.gender,
        helpUserId: this.agentId,
        channel: 2
      },
      confirmReqDto: {
        userId: Stores.AppMod.userInfo.id,
        channel: 2
      }
    };

    // 非实体开卡时，需传密码和重复密码
    if (!physicalCardNum) {
      Object.assign(params.bizValetCardReqDto, {
        password: rstr2b64(this.certNum.slice(-6)),
        confirmPassword: rstr2b64(this.certNum.slice(-6)),
        isEntityCard: '0'
      });
    } else {
      let extension = {};

      headBankList.some((_val) => {
        if (_val.value == headBankId) {
          extension.bankName = _val.name;
          return true;
        }
      });
      if (this.businessAddress) {
        Object.assign(extension, {
          manageProvinceCode: this.businessAddress[0].value,
          manageCityCode: this.businessAddress[1].value,
          manageCountyCode: this.businessAddress[2].value
        });
      }
      Object.assign(
        params.bizValetCardReqDto,
        {
          bankNativePlaceProvinceCode: this.bankAddress[0].value,
          bankNativePlaceCityCode: this.bankAddress[1].value,
          branchCode: this.branchBankId,
          bankAccount: this.bankNum,
          entityCardCode: physicalCardNum,
          entityPassword: physicalCardPwd,
          address: this.detailAddress,
          educational: this.level,
          job: this.job,
          isEntityCard: '1'
        },
        extension
      );
      if (this.businessName) params.bizValetCardReqDto.merchantName = this.businessName;
    }
    const { data } = yield Serv.submitCardMsg(params);
    Toast.success('提交成功，选购礼包即可完成开卡', 1, () => {
      utils.setLocalCache(
        Config.localStorageKeys.member_storeAgentApplyCardMsg,
        params.bizValetCardReqDto
      );
      utils.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);

      utils.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
        dgUserId: this.agentId
      });
      window.app.routerGoTo({
        pathname: '/store/businessManage/businessGiftbag',
        state: {
          // '7'代表店铺新客注册类型的礼包选购
          applyType: '7'
        }
      });
    });
  });

  /**
   * 根据手机号获取健康顾问
   */
  gethealtyByPhone = flow(function* (phone, areaCode) {
    try {
      const result = yield Serv.gethealtyByPhone({ phone, areaCode });
      const { data } = result;
      const { healthConsultantNum } = data || {};
      if (healthConsultantNum) {
        if (this.phoneNumber == phone) return;
        this.phoneNumber = phone;
        this.healthy = this.isMSZ == 1 ? '' : healthConsultantNum;
        Stores.StoreAgentMsgMod.getMemberName('healthyName', healthConsultantNum);
        Stores.AppMod.getCardCodeInfo({ cardCode: healthConsultantNum });
      }
    } catch (error) {}
  });

  /**
   * 查询是否可开实体卡或虚拟卡
   * @param {String} agentId - A代B开卡，B的userId
   * @param {String} healthy - A代B开卡，B的健康顾问
   */
  queryCanApplyType = flow(function* (agentId, healthy, phone) {
    try {
      const params = {
        channel: 2,
        healthConsultantCardCode: healthy
      };
      const { data } = yield Serv.queryCanApplyType(params);
      utils.setLocalCache(Config.localStorageKeys.store_agentUpgradeMember, { dgUserId: agentId });
      // 0 - 只能开虚拟卡，1 - 只能开实体卡，2 - 可开虚拟卡或实体卡
      if (data != 0) {
        // ignoreFictitious: 是否不可开虚拟卡
        window.app.routerGoTo({
          pathname: '/register/physicalCard',
          clear: true,
          state: {
            ignoreFictitious: data == 1,
            applyType: '7',
            agentId,
            healthy,
            phone
          }
        });
      } else {
        window.app.routerGoTo({
          pathname: '/store/businessManage/storeAgentMsg',
          clear: true,
          state: {
            applyType: '7',
            agentId,
            healthy,
            phone
          }
        });
      }
    } catch (error) {}
  });

  getMSZInfo = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.getMSZInfo();
      if (resultCode == 0) {
        this.isMSZ = data.isMsz;
        return !!data.isMsz;
      }
    } catch (error) {}
  });
  applyPhysicalCard = flow(function* () {
    const { cardNum, password } = this;
    try {
      const params = {
        cardCode: cardNum,
        password: rstr2b64(password)
      };
      const result = yield Serv.applyPhysicalCard(params);
      return result;
    } catch (error) {}
  });

  /**
   * 校验实体卡密是否正确
   * @param {String} cardNum - 会员卡号
   * @param {String} password - 会员密码
   * @param {String} applyType - 开卡类型 '7' - 店铺新客注册
   * @param {String} agentId - A代B开卡，B的userId
   * @param {String} healthy - A代B开卡，B的健康顾问
   */
  applyPhysicalCard1 = flow(function* (cardNum, password, applyType, agentId, healthy, phone) {
    try {
      const params = {
        cardCode: cardNum,
        password: rstr2b64(password)
      };
      yield Serv.applyPhysicalCard(params);
      utils.setLocalCache(Config.localStorageKeys.store_agentUpgradeMember, {
        dgCardCode: cardNum,
        dgUserId: agentId
      });
      // 验证成功，跳转开卡
      window.app.routerGoTo({
        pathname: '/store/businessManage/storeAgentMsg',
        clear: true,
        state: {
          physicalCardNum: cardNum,
          physicalCardPwd: rstr2b64(password),
          applyType,
          agentId,
          healthy,
          phone
        }
      });
    } catch (error) {}
  });

  /**
   * 按钮是否不可点
   */
  @computed get disabled() {
    // 是否需要验证码 1 需要 0 不需要
    const { shopValetVerificationCode } = Stores.AppMod.userInfo;
    const cardInfo = Stores.AppMod.cardInfo || {};
    // 实体卡信息是否填写完整
    const permitEntityCard = cardInfo.permitEntityCard;
    const entityCardInfoComplete =
      !permitEntityCard ||
      (!!permitEntityCard &&
        ((!!this.usedPhysical && !!this.cardNum && !!this.password) || !this.usedPhysical));
    if (this.globalSaleMode == 2 && !this.realName) {
      return true;
    }
    return (
      // // !(this.uniqueId && this.code.length > 3 && utils.checkInput(this.phone, 'mobile')) ||
      // !(utils.checkInput(this.phone, 'mobile')) ||
      // (!this.disableNotice && !this.isAgree)
      !(
        (shopValetVerificationCode === 0 ? true : this.uniqueId && this.code.length > 3) &&
        utils.checkInput(this.phone, 'mobile')
      ) ||
      (!this.disableNotice && !this.isAgree) ||
      !entityCardInfoComplete
    );
  }

  /**
   * 获取订单类型列表
   */
  getOrderTypeList = flow(function* (cardCode) {
    try {
      const { data: orderLabelResult } = yield Serv.queryOrderTypeInfo({
        cardCode,
        saleMode: this.globalSaleMode
      });

      let orderTypeList = [];

      if (orderLabelResult) {
        const { retailName = '', vipName = '', retailOrder = 0, vipOrder = 0 } = orderLabelResult;
        if (retailOrder) {
          orderTypeList.push({ label: retailName || '零售订单', value: 1 });
        }
        if (vipOrder) {
          orderTypeList.push({ label: vipName || '复消订单', value: 2 });
        }
      } else {
        orderTypeList = [
          { label: '零售订单', value: 1 },
          { label: '复消订单', value: 2 }
        ];
      }
      return orderTypeList;
    } catch (error) {
      console.log('error===>getOrderTypeList', error);
      return [];
    }
  });
}
const storeAgentRegisterMod = new AgentRegisterMod();
export default storeAgentRegisterMod;



// WEBPACK FOOTER //
// ./src/pages/Store/BusinessManage/AgentRegister/AgentRegisterMod.js